module.exports = __webpack_public_path__ + "static/media/career-tarot.48dca580.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/career-tarot.png
// module id = 1557
// module chunks = 0